import React, { useEffect } from 'react';

import { PageHeader, IframeView } from '../../components';
import { META_TITLE } from '../../utils/constants';
import { buildIframeUrl } from '../../utils/iframe';
import * as S from './AdminUsers.styles';

export default function AdminUsers() {
	useEffect(() => {
		// Set document title
		document.title = `Users | ${META_TITLE}`;
	}, []);

	return (
		<S.Wrapper>
			<PageHeader>Users</PageHeader>
			<IframeView src={buildIframeUrl('spUsers')} title="User Management" />
		</S.Wrapper>
	);
}
